import React, { useState, useEffect} from "react";
import logo from '../../assets/Images/logo.png';
import '../../styles/EduComponents/Introduction.css';

const Introduction = () =>{
  
  const handleClick = () => {
    const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL;
; // replace with your actual TidyCal link
    try {
      window.open(tidycalUrl, '_blank', 'width=600,height=700');
    } catch (error) {
      console.error('Error opening TidyCal booking page:', error);
      alert('An error occurred while trying to open the booking page. Please try again later.');
    }
  };



    return(
        <section className='intro-container'>

      <div className="left-text1">
        <h1>
          Introducing <br />
        </h1>
          <img src ={logo}></img>
            </div>

            <div className= "right-text1">
                <p>
                    <b>Strawket</b> is the simple Academy OS specifically designed for passionate educators like you who are building their dream academics. We understand the administrative hurdles you face. Strawket automates over <b> 80% of these cumbersome </b>tasks, empowering you to easily manage your academy and focus on what truly matters: inspiring your students.
                </p>
                {/* <a href="#" onClick={handleClick}>Book A Demo</a> */}
                <button onClick={handleClick} className="demo-btn6">
     Book a  Demo
    </button>
            </div>
        </section>
    );
}
export default Introduction;